export default "__VITE_ASSET__DAp4gFVM__"